import axios from 'axios';
import { toastError, toastSuccess } from 'utils/toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Accept-Language': 'pt' },
  withCredentials: true,
});

let AuthContext = { refresh: null, logout: null };

export const setApiContext = (ctx) => {
  AuthContext = ctx;
};

api.interceptors.response.use(
  (res) => {
    if (res?.status !== 200) {
      toastSuccess(res);
    }
    return res;
  },
  async (error) => {
    const prevRequest = error?.config;
    const status = error?.response?.status;
    const isAuthError = status === 401;
    if (isAuthError && !prevRequest?._retry && !prevRequest?.skipRetry) {
      prevRequest._retry = true;

      try {
        if (AuthContext.refresh) {
          await AuthContext.refresh();

          const Authorization = api.defaults.headers.common['Authorization'];
          prevRequest.headers = { ...prevRequest.headers, Authorization };

          return api(prevRequest);
        }
      } catch (err) {
        if (AuthContext.logout) {
          await AuthContext.logout();
        }
        return Promise.reject(error);
      }
    }

    if (![401, 403]?.includes(status)) {
      toastError(error);
    }

    return Promise.reject(error);
  }
);

export default api;
